// OVERVIEW page — game overview + the Mao Coin peg table.
// Replaces the generic stub for this page so the currency is documented in one
// canonical place that the player can reach from the nav.

import { MaoCoinConfig } from '../../config/balance.js'
import { formatCoins, formatUsd } from '../format.js'

export function mountOverviewPage({ root }) {
  const pegRows = MaoCoinConfig.pegTable
    .map(
      (row) => `
      <tr>
        <td class="coin">${formatCoins(row.coins)}</td>
        <td class="usd">${formatUsd(row.usd)}</td>
      </tr>
    `,
    )
    .join('')

  root.innerHTML = `
    <div class="page-stub">
      <h1>Overview</h1>
      <p class="page-stub-sub">What is the Mao Kingdom?</p>
      <div class="page-stub-grid">
        <div class="page-stub-card">
          <div class="page-stub-card-title">THE WORLD</div>
          <p>Three kingdoms — Wei, Han, Wu — at the dawn of the Three Kingdoms era. Each has its own field, its own court, its own historical figures.</p>
        </div>
        <div class="page-stub-card">
          <div class="page-stub-card-title">THE PLAY</div>
          <p>Rice farming as ritual. Click through PREP, PLANT, MAINTAIN, HARVEST. Earn coin. Educate yourself, win an election seat, marry into power.</p>
        </div>
        <div class="page-stub-card">
          <div class="page-stub-card-title">THE ECONOMY</div>
          <p>Mao Coin (m) is the in-world currency. It pegs to USD at micro-cent levels — see the table below.</p>
        </div>
      </div>
      <div class="page-peg">
        <div class="page-peg-title">MAO COIN — USD PEG</div>
        <table class="page-peg-table">
          <thead><tr><th>Mao Coin</th><th>USD</th></tr></thead>
          <tbody>${pegRows}</tbody>
        </table>
        <p class="page-peg-note">Rate: 1m = ${formatUsd(MaoCoinConfig.usdPerCoin)}. Internal balances stay in raw Mao Coin units for precision; the USD value is a view-only conversion.</p>
      </div>
    </div>
  `
}
